import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import InviteScreen from "@/components/InviteScreen";

function App() {
  return (
    <div className="App grain">
      <InviteScreen />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1F211D",
            color: "#F9F8F5",
            borderRadius: 0,
            border: "1px solid #D5D2C8",
          },
        }}
      />
    </div>
  );
}

export default App;
